module.exports = __webpack_public_path__ + "img/edge2-min.jpg";